(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["availability-update"] && !Shopify.designMode) return;
  try {
    (() => {
    const countdownSelector = '[data-mm-availability-countdown]';
    const unitsBadgeSelector = 'section-store--pulse-badge-block';
    const unitsState = window.mmUnitsAvailabilityState || {};
    const observedUnitsBadges = window.mmObservedUnitsBadges || new WeakSet();
    const madridFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    window.mmUnitsAvailabilityState = unitsState;
    window.mmObservedUnitsBadges = observedUnitsBadges;

    const madridTimeParts = () => Object.fromEntries(
      madridFormatter.formatToParts(new Date()).map(({ type, value }) => [type, value])
    );

    const productKey = () => `mm-demo-units:${window.location.pathname}`;

    const productHash = () => Array.from(window.location.pathname).reduce(
      (total, character) => (total + character.charCodeAt(0)) % 10,
      0
    );

    const getUnitsValue = () => {
      const timeParts = madridTimeParts();
      const timeSlot = Math.floor((Number(timeParts.hour) * 60 + Number(timeParts.minute)) / 5);
      const key = productKey();

      if (unitsState.key === key && unitsState.timeSlot === timeSlot) {
        return unitsState.value;
      }

      let value = ((timeSlot + productHash()) % 10) + 1;
      let previousValue = 0;

      try {
        previousValue = Number(window.localStorage.getItem(key));
      } catch (error) {
        previousValue = Number(unitsState.value) || 0;
      }

      if (value === previousValue) {
        value = value === 10 ? 1 : value + 1;
      }

      unitsState.key = key;
      unitsState.timeSlot = timeSlot;
      unitsState.value = value;

      try {
        window.localStorage.setItem(key, String(value));
      } catch (error) {
        unitsState.value = value;
      }

      return value;
    };

    const updateUnitsBadges = () => {
      const value = getUnitsValue();

      document.querySelectorAll(unitsBadgeSelector).forEach((badge) => {
        const root = badge.shadowRoot;
        const body = root?.querySelector('.body');
        const content = root?.querySelector('.content');
        const currentNumber = root?.querySelector('.text strong')?.textContent;
        const hasCurrentStyle = Boolean(root?.querySelector('#mm-demo-units-style'));
        const isCurrentValue = badge.dataset.mmUnitsValue === String(value) && currentNumber === String(value);

        if (!root || !body || !content) {
          return;
        }

        if (!observedUnitsBadges.has(badge)) {
          const observer = new MutationObserver(() => updateUnitsBadges());
          observer.observe(root, { childList: true, subtree: true });
          observedUnitsBadges.add(badge);
        }

        if (isCurrentValue && hasCurrentStyle) {
          return;
        }

        let style = root.querySelector('#mm-demo-units-style');
        if (!style) {
          style = document.createElement('style');
          style.id = 'mm-demo-units-style';
          style.textContent = '.content{display:flex;align-items:center;justify-content:flex-start;gap:10px}.mm-units-dot{width:8px;height:8px;border-radius:50%;background:#bf795a;flex:0 0 auto}.text p{margin:0;color:#5f4d49;font-size:14px;line-height:1.4;letter-spacing:.04em}.text strong{color:inherit;font-weight:700}';
          root.append(style);
        }

        const dot = document.createElement('span');
        dot.className = 'mm-units-dot';
        dot.setAttribute('aria-hidden', 'true');

        const text = document.createElement('div');
        text.className = 'text';
        const paragraph = document.createElement('p');
        paragraph.append(value === 1 ? 'Queda ' : 'Quedan ');
        const number = document.createElement('strong');
        number.textContent = String(value);
        paragraph.append(number, value === 1 ? ' unidad disponible' : ' unidades disponibles');
        text.append(paragraph);
        content.replaceChildren(dot, text);

        body.style.setProperty('--background-color', 'transparent');
        body.style.setProperty('--text-color', '#5f4d49');
        body.style.setProperty('--padding-top', '0px');
        body.style.setProperty('--padding-bottom', '0px');
        badge.dataset.mmUnitsValue = String(value);
        badge.setAttribute(
          'aria-label',
          value === 1 ? 'Queda 1 unidad disponible' : `Quedan ${value} unidades disponibles`
        );
      });
    };

    const scheduleUnitsBadgeUpdates = () => {
      [0, 100, 300, 700, 1500, 3000, 5000].forEach((delay) => {
        window.setTimeout(updateUnitsBadges, delay);
      });
    };

    const updateCountdowns = () => {
      const timeParts = madridTimeParts();
      const elapsedSeconds = Number(timeParts.hour) * 3600 + Number(timeParts.minute) * 60 + Number(timeParts.second);
      const remainingSeconds = 86400 - elapsedSeconds;
      const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
      const seconds = String(remainingSeconds % 60).padStart(2, '0');
      const value = `${hours}:${minutes}:${seconds}`;

      document.querySelectorAll(countdownSelector).forEach((countdown) => {
        countdown.textContent = value;
      });

    };

    document.querySelectorAll('#mm-countdown-box').forEach((countdown) => {
      countdown.hidden = true;
    });

    updateCountdowns();
    scheduleUnitsBadgeUpdates();
    window.clearInterval(window.mmAvailabilityCountdownInterval);
    window.clearInterval(window.mmUnitsAvailabilityInterval);
    window.mmAvailabilityCountdownInterval = window.setInterval(updateCountdowns, 1000);
    window.mmUnitsAvailabilityInterval = window.setInterval(updateUnitsBadges, 60000);
    document.addEventListener('shopify:section:load', () => {
      updateCountdowns();
      scheduleUnitsBadgeUpdates();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mocasines-size-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const sizeRanges = [
      { max: 21.7, size: '34' },
      { max: 22.4, size: '35' },
      { max: 23.0, size: '36' },
      { max: 23.6, size: '37' },
      { max: 24.3, size: '38' },
      { max: 25.0, size: '39' },
      { max: 25.6, size: '40' },
      { max: 26.3, size: '41' },
      { max: 27.0, size: '42' },
      { max: 27.7, size: '43' },
      { max: 28.3, size: '44' },
      { max: 29.0, size: '45' },
      { max: 29.7, size: '46' }
    ];

    const initializeShoeSizeCalculator = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-mm-moc-shoe-dialog]');
      const openButton = root.querySelector('[data-mm-moc-shoe-open]');
      const closeButton = root.querySelector('[data-mm-moc-shoe-close]');
      const calculateButton = root.querySelector('[data-mm-moc-shoe-calculate]');
      const lengthInput = root.querySelector('[data-mm-moc-shoe-length]');
      const result = root.querySelector('[data-mm-moc-shoe-result]');
      const resultValue = root.querySelector('[data-mm-moc-shoe-value]');
      const error = root.querySelector('[data-mm-moc-shoe-error]');
      const unavailable = root.querySelector('[data-mm-moc-shoe-unavailable]');
      const normalizeSize = (value) => String(value).trim().replace(/^EU\s*/i, '');
      let offeredSizes = [];
      try {
        const options = JSON.parse(root.querySelector('[data-mm-moc-shoe-options]').textContent);
        const sizeOption = options.find((option) => /talla|size|tama[ñn]o|n[uú]mero/i.test(option.name)) || options.find((option) => option.values.every((value) => /^\d{2}$/.test(normalizeSize(typeof value === 'string' ? value : value.name))));
        if (sizeOption) offeredSizes = sizeOption.values.map((value) => normalizeSize(typeof value === 'string' ? value : value.name));
      } catch (error) { offeredSizes = []; }
      root.querySelectorAll('[data-mm-moc-shoe-row]').forEach((row) => {
        if (offeredSizes.length) row.hidden = !offeredSizes.includes(row.dataset.mmMocShoeRow);
      });
      const tabs = root.querySelectorAll('[data-mm-moc-shoe-tab]');
      const panels = root.querySelectorAll('[data-mm-moc-shoe-panel]');

      openButton.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => openButton.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.mmMocShoePanel !== tab.dataset.mmMocShoeTab;
          });
        });
      });

      tabs.forEach((tab, index) => {
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[nextIndex].click(); tabs[nextIndex].focus();
        });
      });
      const calculate = () => {
        const normalizedLength = lengthInput.value.trim().replace(',', '.');
        const footLength = /^\d{2}(?:\.\d{1,2})?$/.test(normalizedLength) ? Number(normalizedLength) : NaN;
        const recommendedRange = sizeRanges.find((range) => footLength <= range.max);

        if (!Number.isFinite(footLength) || footLength < 21.1 || footLength > 29.7 || !recommendedRange) {
          lengthInput.setAttribute('aria-invalid', 'true');
          error.hidden = false;
          result.hidden = true;
          return;
        }

        root.querySelectorAll('[data-mm-moc-shoe-row]').forEach((row) => row.classList.remove('is-recommended'));
        lengthInput.removeAttribute('aria-invalid');
        error.hidden = true;
        unavailable.hidden = !offeredSizes.length || offeredSizes.includes(recommendedRange.size);
        resultValue.textContent = recommendedRange.size;
        result.hidden = false;
        const row = root.querySelector(`[data-mm-moc-shoe-row="${recommendedRange.size}"]`);
        if (row) row.classList.add('is-recommended');
      };

      calculateButton.addEventListener('click', calculate);
      lengthInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') { event.preventDefault(); calculate(); }
      });
    };

    const initializeAllShoeSizeCalculators = (scope = document) => {
      scope.querySelectorAll('[data-mm-moc-shoe-size]').forEach(initializeShoeSizeCalculator);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllShoeSizeCalculators(), { once: true });
    } else { initializeAllShoeSizeCalculators(); }
    document.addEventListener('shopify:section:load', (event) => initializeAllShoeSizeCalculators(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shoe-size-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const sizeRanges = [
      { max: 23.0, size: '36' },
      { max: 23.6, size: '37' },
      { max: 24.3, size: '38' },
      { max: 25.0, size: '39' },
      { max: 25.6, size: '40' },
      { max: 26.3, size: '41' },
      { max: 27.0, size: '42' },
      { max: 27.7, size: '43' }
    ];

    const initializeShoeSizeCalculator = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-mm-shoe-dialog]');
      const openButton = root.querySelector('[data-mm-shoe-open]');
      const closeButton = root.querySelector('[data-mm-shoe-close]');
      const calculateButton = root.querySelector('[data-mm-shoe-calculate]');
      const lengthInput = root.querySelector('[data-mm-shoe-length]');
      const result = root.querySelector('[data-mm-shoe-result]');
      const resultValue = root.querySelector('[data-mm-shoe-value]');
      const error = root.querySelector('[data-mm-shoe-error]');
      const tabs = root.querySelectorAll('[data-mm-shoe-tab]');
      const panels = root.querySelectorAll('[data-mm-shoe-panel]');

      openButton.addEventListener('click', () => dialog.showModal());
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => openButton.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.mmShoePanel !== tab.dataset.mmShoeTab;
          });
        });
      });

      const calculate = () => {
        const footLength = Number.parseFloat(lengthInput.value.trim().replace(',', '.'));
        const recommendedRange = sizeRanges.find((range) => footLength <= range.max);

        if (!Number.isFinite(footLength) || footLength < 22.5 || footLength > 27.7 || !recommendedRange) {
          error.hidden = false;
          result.hidden = true;
          return;
        }

        root.querySelectorAll('[data-mm-shoe-row]').forEach((row) => row.classList.remove('is-recommended'));
        error.hidden = true;
        resultValue.textContent = recommendedRange.size;
        result.hidden = false;
        const row = root.querySelector(`[data-mm-shoe-row="${recommendedRange.size}"]`);
        if (row) row.classList.add('is-recommended');
      };

      calculateButton.addEventListener('click', calculate);
      lengthInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') calculate();
      });
    };

    const initializeAllShoeSizeCalculators = (scope = document) => {
      scope.querySelectorAll('[data-mm-shoe-size]').forEach(initializeShoeSizeCalculator);
    };

    initializeAllShoeSizeCalculators();
    document.addEventListener('shopify:section:load', (event) => initializeAllShoeSizeCalculators(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
    const bmiLimits = [19, 21.5, 24, 27, 30.5, 34, 38, 42.5];
    const buildAdjustments = { slim: -1.2, athletic: -0.4, robust: 1.4 };

    const initializeSizeCalculator = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-mm-size-dialog]');
      const openButton = root.querySelector('[data-mm-size-open]');
      const closeButton = root.querySelector('[data-mm-size-close]');
      const calculateButton = root.querySelector('[data-mm-size-calculate]');
      const result = root.querySelector('[data-mm-size-result]');
      const resultValue = root.querySelector('[data-mm-size-value]');
      const error = root.querySelector('[data-mm-size-error]');
      const tabs = root.querySelectorAll('[data-mm-size-tab]');
      const panels = root.querySelectorAll('[data-mm-size-panel]');

      openButton.addEventListener('click', () => dialog.showModal());
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => openButton.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.mmSizePanel !== tab.dataset.mmSizeTab;
          });
        });
      });

      calculateButton.addEventListener('click', () => {
        const height = Number.parseFloat(root.querySelector('[data-mm-height]').value);
        const weight = Number.parseFloat(root.querySelector('[data-mm-weight]').value);
        const selectedBuild = root.querySelector('[data-mm-build]:checked');

        if (!Number.isFinite(height) || !Number.isFinite(weight) || !selectedBuild || height < 140 || height > 210 || weight < 35 || weight > 200) {
          error.hidden = false;
          result.hidden = true;
          return;
        }

        const heightInMetres = height / 100;
        const bmi = weight / (heightInMetres * heightInMetres);
        const adjustedBmi = bmi + buildAdjustments[selectedBuild.value];
        const sizeIndex = bmiLimits.findIndex((limit) => adjustedBmi < limit);
        const recommended = sizes[sizeIndex === -1 ? sizes.length - 1 : sizeIndex];
        root.querySelectorAll('[data-mm-size-row]').forEach((row) => row.classList.remove('is-recommended'));

        error.hidden = true;
        resultValue.textContent = recommended;
        result.hidden = false;
        const row = root.querySelector(`[data-mm-size-row="${recommended}"]`);
        if (row) row.classList.add('is-recommended');
      });
    };

    const initializeAllSizeCalculators = (scope = document) => {
      scope.querySelectorAll('[data-mm-size-calculator]').forEach(initializeSizeCalculator);
    };

    initializeAllSizeCalculators();
    document.addEventListener('shopify:section:load', (event) => initializeAllSizeCalculators(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
